import { FC } from 'react'

import { StarSelector } from '@syconium/little-miss-figgy'

import { MaybeSpaLink } from '../../../../../../../../../lib/adapters/next-routing-service/MaybeSpaLink'
import { trackEvent } from '../../../../../../../../../lib/analytics'
import { EditorialCell } from '../../../../../../../../../types/graphql'
import { EditorialCellDescriptionSize, EditorialCellTitle } from '../../types'
import {
  Cta,
  Description,
  DescriptionBody,
  DescriptionWrapper,
  Eyebrow,
  LinkDescription,
  StarWrapper,
  Subtitle,
  Title,
} from '../styles'

interface EditorialCellDescription extends Partial<NonNullable<EditorialCell>> {
  isFloating?: boolean
  showModalCta?: boolean | '' | null
}

const EditorialCellDescription: FC<EditorialCellDescription> = ({
  description,
  isFloating,
  descriptionPadding,
  descriptionAlignment,
  descriptionByLine,
  reviewStars,
  descriptionSize: requestedDescriptionSize,
  linkHref,
  ctaText,
  descriptionColor,
  title,
  titleSize: requestedTitleSize,
  showModalCta,
  titleAlignment,
  textColor,
  subtitle,
  eyebrow,
}) => {
  // We have to cast this because type gen types it as a string due to enum
  // not being an option. There are spaces in its values that would need to
  // be migrated away from to type gen as an enum.
  const descriptionSize = requestedDescriptionSize as
    | EditorialCellDescriptionSize
    | null
    | undefined
  const titleSize = requestedTitleSize as EditorialCellTitle | null | undefined

  const getTrackEventProps = () =>
    trackEvent({
      category: 'editorial cell',
      action: 'click editorial cell',
      value: ctaText ?? '',
    })

  return (
    <DescriptionWrapper textAlign={descriptionAlignment}>
      <DescriptionBody paddingX={descriptionPadding} isFloating={isFloating}>
        {title && (
          <Title
            titleSize={titleSize}
            titleAlignment={titleAlignment ?? undefined}
            textColor={textColor ?? undefined}
          >
            {title}
          </Title>
        )}
        {subtitle && (
          <Subtitle titleAlignment={titleAlignment ?? undefined} textColor={textColor}>
            {subtitle}
          </Subtitle>
        )}
        {reviewStars === true && (
          <StarWrapper textAlign={descriptionAlignment}>
            <StarSelector disabled rating={5} starSize='18px' />
          </StarWrapper>
        )}
        {eyebrow && <Eyebrow textAlign={descriptionAlignment}>{eyebrow}</Eyebrow>}
        {description && (
          <Description descriptionColor={descriptionColor} fontSize={descriptionSize}>
            {description}
          </Description>
        )}
        {linkHref ? (
          <MaybeSpaLink href={linkHref} {...getTrackEventProps()}>
            <Cta color={descriptionColor || textColor}>{ctaText}</Cta>
          </MaybeSpaLink>
        ) : (
          !showModalCta && <Cta color={descriptionColor || textColor}>{ctaText}</Cta>
        )}
        {descriptionByLine && (
          <LinkDescription textAlign={descriptionAlignment}>- {descriptionByLine}</LinkDescription>
        )}
      </DescriptionBody>
    </DescriptionWrapper>
  )
}

export default EditorialCellDescription
